import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { PageService } from 'src/app/services/page.service';
import { AuthService } from 'src/app/services/auth.service';
import { AppService } from 'src/app/services/app.service';
import { cloneDeep, get, rest } from 'lodash';
import { MultiLangPipe } from 'src/app/pipes/multi-lang.pipe';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
//import { SwUpdate } from '@angular/service-worker';
import * as jsonpatch from "fast-json-patch";
import { applyOperation, compare } from "fast-json-patch";
import { HttpXsrfTokenExtractor } from '@angular/common/http';
import { RecaptchaErrorParameters } from 'ng-recaptcha';
import { map } from 'rxjs/operators';



@Component({
  selector: 'app-form-patch',
  templateUrl: './form-patch.component.html',
  styleUrls: ['./form-patch.component.scss'],
})
export class FormPatchComponent implements OnInit, AfterViewInit {

  @ViewChild('captchaRef') captchaRef: any;
  @Input() public data: any;
  @Input() public config: {
    name?: string
    submitButton?: {
      backgroundColor?: string,
      borderColor?: string,
      text?: string | Array<{ languageCode: string, value: string }>,
      color?: string,
      align?: string,
      size?: string
    },
    afterSubmit?: {
      mode?: number,
      message?: Array<{ languageCode: string, value: string }>,
      redirectUrl?: Array<{ languageCode: string, value: string }>
    },
    patchForm?: string,
    formType?: string
  };

  public form: UntypedFormGroup;
  public fields: Array<any>;
  public templateId: string;
  public instanceId: string;
  public entityCode: string;
  public inProgress: boolean = false;
  public successMessage: string = 'Form submitted successfully';
  public submitButton = {
    backgroundColor: `#10dc60`,
    borderColor: `#10dc60`,
    text: `Submit`,
    color: `#ffffff`,
    align: `flex-start`,
    size: 'default'
  };
  fileNames: string[] = [];
  uploadSuccess: boolean[] = [];
  @ViewChild('submitButtonRef', { read: ElementRef }) submitButtonRef;
  wrapperStyle: any;

  reactiveForm: FormGroup;
  token: string | undefined;
  isPatchRequestArray: boolean;
  basePath: any;
  fileName: string;
  uploadInProgress: boolean;

  constructor(
    private pageService: PageService,
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private authService: AuthService,
    private appService: AppService,
    public multiLangPipe: MultiLangPipe,
    private renderer: Renderer2,
    private tokenExtractor: HttpXsrfTokenExtractor,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.token = undefined;
  }

  ngOnInit() {
    //NOTE: TODO: FORM FIELDS FOR CUSTOM DATA TYPES
    //console.log(this.config);
    //console.log(this.pageService);
    this.templateId = this.pageService.ditemplateId;
    this.instanceId = this.pageService.diinstanceId;
    this.entityCode = this.pageService.entityCode;

    const { patchForm } = this.config;
    if (patchForm) {
      const [requestGroup] = this.getRequestGroup(patchForm);
      //console.log({requestGroup});
      if (requestGroup) {
        this.basePath = requestGroup.attributeValue;
        const { fields } = requestGroup;
        if (fields && fields.length) {
          this.fields = [...fields];
          this.form = this.generateFormGroup(fields, this.pageService.diData);

        }

      }

      const { message } = this.config.afterSubmit;
      if (message) {

        const afterSubmitMessage = this.multiLangPipe.transform(message).toString();
        if (afterSubmitMessage) {
          this.successMessage = afterSubmitMessage;
        }

      }


      const { submitButton } = this.config;
      if (submitButton) {
        this.configureSubmitButton(submitButton);
      }


    }
  }

  public send(forms: NgForm): void {
    if (forms.invalid) {
      for (const control of Object.keys(forms.controls)) {
        forms.controls[control].markAsTouched();
      }
      return;
    }
    console.debug(`Token [${this.token}] generated`);
  }

  /**
   * Return patchRequest group from template settings
   * @author Neil C 
   * @task QLIKTAG-4053
   * @param patchForm 
   */
  getRequestGroup(patchForm) {
    const { advanced: { patchRequests } } = this.pageService.diLayout;
    const { advanced: { patchRequestsArray } } = this.pageService.diLayout;

    if (patchRequests) {
      const { isPatchRequestsEnabled, requests } = patchRequests;
      
      //console.log({isPatchRequestsEnabled, requests})
      if (isPatchRequestsEnabled && requests.length) {
        let form =  requests.filter(({ requestCode }) => requestCode === patchForm);
        if(form.length>0) return form;

      }
    }

    if (patchRequestsArray) {
      this.isPatchRequestArray = true;
      const { isPatchRequestsArrayEnabled, requestsArray } = patchRequestsArray;
      
      //console.log({isPatchRequestsEnabled, requests})
      if (isPatchRequestsArrayEnabled && requestsArray.length) {
        let form =  requestsArray.filter(({ requestCode }) => requestCode === patchForm);
        if(form.length>0) return form;


      }
    }
    return [];
  }

  /**
   * Generate formGroup for fields array
   * @author Neil C 
   * @task QLIKTAG-4053
   * @param fields 
   * @returns 
   */
  generateFormGroup(fields, model?): UntypedFormGroup {
    let fg: UntypedFormGroup;
    fg = fields.reduce((acc, field, index) => {

      const validators = [];
      if (field.isRequired) {
        validators.push(Validators.required)
      }

      let value = null;

      if (field.type === 'checkbox') {
        value = false; //default value for boolean
      }


      if (model) {

        const path = field.path.split('/');

        if (path.length) {
          path.shift();
          //console.log(path);
          value = get(model, path.join('.'));
          if (!value) {
            value = null;

            if (field.type === 'checkbox') {
              value = false; //default value for boolean
            }
          }
        }

      }
      if(field.$listCode && (field.$listCode.endsWith('/definitions/assetImageType') || field.$listCode.endsWith('/definitions/assetDocumentType'))){
        
        if(field.label === 'Type' && field.$listCode.endsWith('/definitions/assetImageType')){
          value = 'image'
        }else if(field.label === 'Type' && field.$listCode.endsWith('/definitions/assetDocumentType')){
          value = 'document'
        }

        if(field.label === 'Language Code'){
          value = "en"
        }
    }

      acc[`field_${index}`] = this.formBuilder.control(value, validators);
      return acc;
    }, {});

    // Add reCAPTCHA control
    //fg['recaptcha'] = this.formBuilder.control(null, Validators.required);
    // Add honeypot control
    fg['customPotName1'] = this.formBuilder.control('');
    fg['customPotName2'] = this.formBuilder.control('');
    fg['customPotName3'] = this.formBuilder.control('');

    return this.formBuilder.group({ ...fg });
  }

  /**
   * On Submit form handler
   * @author Neil C 
   * @task QLIKTAG-4053
   */




  onSubmit() {


    if (this.form.get('customPotName1').value || this.form.get('customPotName2').value || this.form.get('customPotName3').value) {
      // It's a bot
      console.log('Bot detected!');

      return;
    }
    // Trigger the reCAPTCHA

    if (this.captchaRef) {
      (this.captchaRef as any).execute();
    }


  }


  onRecaptchaResolved(token: string) {
    let patch;
    patch = [...this.getPatchArray(this.fields, this.pageService.diData)];
    patch = this.ensureArrayInPatch(patch);
    patch = this.transformDataFileArrayToObject(patch);


    // console.log({ patch })
    patch[0].path.split('/').trim
    if (patch.length) {

      patch = [...this.filterPatchArray(patch)];
      // let filepatch = this.createSeparatePatches(patch);
      let patchForm = this.config.patchForm

      const body = {
        data: {
          patch
        }
      }


      // console.log({ body });
      //NOTE HANDLE TOKEN EXPIRED VIA INTERCEPTOR

      //NOTE HANDLE TOKEN EXPIRED VIA INTERCEPTOR
      if (this.templateId && this.entityCode && this.instanceId) {
        const endpoint = `entity/ditemplate/${this.templateId}/${this.entityCode}/${this.instanceId}`;
        this.inProgress = true;
        if (this.authService.accessToken) {
          //NOTE Provide auth token
          this.apiService.patch(endpoint, body, this.authService.accessToken)
            .subscribe((res) => {
              //console.log(res)
              //this.refreshData();
              this.appService.makeToast(this.successMessage).then(() => {
                this.inProgress = false;
                setTimeout(() => {
                  location.reload();
                }, 2000)
              });
            }, (err) => {
              console.log(err);
              this.inProgress = false;
              this.appService.makeToast('Something went wrong');
            })
        } else {
          // Prepare headers with only XSRF token
          const xsrf = this.tokenExtractor.getToken() as string;

          this.apiService.patch(endpoint, body, null, xsrf, patchForm)
            .subscribe((res) => {
              //console.log(res)
              //this.refreshData();
              this.appService.makeToast(this.successMessage).then(() => {
                this.inProgress = false;
                setTimeout(() => {
                  location.reload();
                }, 2000)
              });
            }, (err) => {
              console.log(err);
              this.inProgress = false;
              this.appService.makeToast('Something went wrong');
            })
        }
      }

    }
  }

  /**
   * Get patch array 
   * @author Neil C 
   * @task QLIKTAG-4053
   * @param fields 
   * @returns 
   */
  getPatchArray(fields, model = { data: {} }) {

    //console.log({ fields, model })

    //Compare current model with patched model to generate patch array
    //create function to create a patched model

    const patchedModel = this.patchModel(model, this.fields, this.form); //only subset data object will be patched

    //model[data] vs patchedModel;
    //console.log({ model: model['data'], patchedModel })
    //console.log('patch array', compare(model['data'], patchedModel));

    const patch = compare(model['data'], patchedModel)
      .map(({ path, ...rest }) => {
        return ({
          ...rest,
          path: `/data${path}` //Append data to every patch array path
        })
      })


    // if (patch[0].op == 'add' && !this.basePath) { // for new insertion , not array
    //   let path = patch[0].path.split('/');
    //   const lastSeg = path.pop();
    //   const newPath = path.join("/");
    //   const newValue = {
    //     ...patch[0].value,
    //   }
    //   patch[0] = {
    //     op: patch[0].op,
    //     path: newPath || "/",
    //     value: {
    //       [lastSeg]: newValue
    //     }
    //   };
    // }
    return patch;
  }


  ensureArrayInPatch(patch: any): any {
    if (!patch || !Array.isArray(patch) || patch.length === 0) {
      throw new Error("Invalid patch format");
    }

    const path = patch[0].path.split('/').filter(key => key);
    const newValue = patch[0].value;
    const segment = patch[0].path.split('/').filter(Boolean);
    const lastSeg = segment[segment.length-1];
    const isIndex = !isNaN(Number(lastSeg));


    // Check if the value contains an object and wrap it in an array if necessary
    if (typeof newValue === 'object' && !Array.isArray(newValue)) {
      // Iterate over the keys in the newValue object
      for (const key in newValue) {
        if (newValue.hasOwnProperty(key) && typeof newValue[key] === 'object' && !Array.isArray(newValue[key])) {
          // Wrap the object in an array
          newValue[key] = [newValue[key]];
          if(!Array.isArray(newValue) && !isIndex) patch[0].value = [newValue]
        }else if(this.basePath && !isIndex){
          patch[0].value = [newValue]
        }
      }
    }

    return patch;
  }

  transformDataFileArrayToObject(patch) {
    patch.forEach(operation => {
      if (operation.op === "add" && operation.value) {
        if (Array.isArray(operation.value)) {
          operation.value.forEach(item => {
            for (const key in item) {
              if (Array.isArray(item[key])) {
                const arrayItem = item[key][0];
                if (arrayItem && arrayItem.url && arrayItem.languageCode && arrayItem.type && !Array.isArray(arrayItem.languageCode)) {
                  if (typeof arrayItem.url =='string' && arrayItem.url.match(/\.(jpeg|jpg|gif|png)$/i) || arrayItem.url.match(/\.(pdf|doc|docx)$/i)) {
                    // Convert languageCode to an array
                    arrayItem.languageCode = this.pageService.controllerLanguages;
                    item[key] = arrayItem;
                  }
                }
              }else if(typeof item[key] !== 'object'){
                if(item.url && item.languageCode && item.type && !Array.isArray(item.languageCode)){
                  if(typeof item.url =='string' && item.url.match(/\.(jpeg|jpg|gif|png)$/i) || item.url.match(/\.(pdf|doc|docx)$/i)) {
                    // Convert languageCode to an array
                    item.languageCode = this.pageService.controllerLanguages;
                  }
                }
              }
            }
          });
        } else {
          for (const key in operation.value) {
            if (Array.isArray(operation.value[key])) {
              const arrayItem = operation.value[key][0];
              if (arrayItem && arrayItem.url && arrayItem.languageCode && arrayItem.type && !Array.isArray(arrayItem.languageCode)) {
                if (arrayItem.url.match(/\.(jpeg|jpg|gif|png)$/i) || arrayItem.url.match(/\.(pdf|doc|docx)$/i)) {
                  // Convert languageCode to an array
                  arrayItem.languageCode = this.pageService.controllerLanguages;
                  operation.value[key] = arrayItem;
                }
              }
            } else {
              const item = operation.value;
              if (typeof item[key] === 'object' && !Array.isArray(item[key].languageCode) && item[key].url && item[key].languageCode && item[key].type) {
                if (item[key].url.match(/\.(jpeg|jpg|gif|png)$/) || item.url.match(/\.(pdf|doc|docx)$/i)) {
                  item[key].languageCode = this.pageService.controllerLanguages;
                }
              }else if(typeof item === 'object' && !Array.isArray(item.languageCode) && item.url && item.languageCode && item.type){
                  if(item.url.match(/\.(jpeg|jpg|gif|png)$/) || item.url.match(/\.(pdf|doc|docx)$/i)){
                    item.languageCode = this.pageService.controllerLanguages;
                  }
              }
            }
          }
        }
      } else if (operation.value) {
        if (operation.value.match(/\.(pdf|doc|docx)$/i)) {
          const oldValue = operation.value; // Assuming you have the old value stored somewhere
          operation.path = operation.path.split('/').slice(0, -1).join('/');
          operation.value = {
            url: oldValue,
            languageCode: this.pageService.controllerLanguages,
            type: 'document'
          };
        } else if (operation.value.match(/\.(jpeg|jpg|gif|png)$/i)) {
          const oldValue = operation.value; // Assuming you have the old value stored somewhere
          operation.path = operation.path.split('/').slice(0, -1).join('/');
          operation.value = {
            url: oldValue,
            languageCode: this.pageService.controllerLanguages,
            type: 'image'
          };
        }
      }
    });
    return patch.filter(operation => {
      if (operation.op === "replace" && operation.value) {
        const pathEndsWithLanguageCode = operation.path.endsWith("/languageCode") && operation.value === "en";
        const pathEndsWithType = operation.path.endsWith("/type") && (operation.value === "document" || operation.value === "image");
  
        if (pathEndsWithLanguageCode || pathEndsWithType) {
          return false; // Remove this operation
        }
      }
      return true; // Keep this operation
    });
  }


  /**
   * Eliminate empty {} from patchArray
   * @param patchArray 
   * @returns filtered patch array
   * @author NeilC 
   * @task QLIKTAG-4094
   */
  filterPatchArray(patchArray = []): Array<any> {

    const filteredPatchArray = patchArray.reduce((acc, item) => {
      const { value } = item;

      if (typeof value === 'object' && !Array.isArray(value) && value !== null) { //only objects

        const filteredValue = this.removeEmptyProperties(value);

        if (Object.keys(filteredValue).length > 0) {
          acc.push(item);
        }

      } else {
        acc.push(item);
      }


      // if (op === 'add' && Object.getPrototypeOf(value) === Object.prototype) {

      //   //Only if it has keys push it in, eliminate empty array;
      //   if (Object.keys(value).length > 0) {
      //     acc.push(item);
      //   }

      // } else {
      //   acc.push(item);
      // }

      return acc;

    }, []);

    console.log({ filteredPatchArray })
    return filteredPatchArray

  }

  /**
   * Remove blank object keys
   * @author NEil C 
   * @param obj 
   * @returns 
   */
  removeEmptyProperties(obj) {

    const filtered = Object.keys(obj).reduce((acc, key) => {
      if (obj[key] && Object.getPrototypeOf(obj[key]) === Object.prototype) {
        if (Object.keys(obj[key]).length > 0) {
          obj[key] = this.removeEmptyProperties(obj[key]);
          acc[key] = obj[key];
        } else {
          delete obj[key];
        }
      } else {
        acc[key] = obj[key];
      }
      return acc;

    }, {});

    return filtered;

  }


  /**
   * Patch a copy of the existing diData for fast-json patch to generate a patcharray
   * @param model 
   * @param fields 
   * @param formGroup 
   * @author Neil C 
   * @task QLIKTAG-4094
   * @returns 
   */
  patchModel(model: any = {}, fields: Array<any>, formGroup: UntypedFormGroup): any {
    //console.log({ model, fields, formGroup });
    const { data = {} } = model;
    let result = cloneDeep(data);

    const isLastIndex = (arr, index) => arr.length && (arr.length - index) === 1;

    let paths = fields.map(({ path }) => path);

    paths = this.updatePathsIfArrayPresent(model, this.basePath, paths)

    if (paths.length) {

      paths.forEach((path, pathIndex) => {
        let pathArr = [];
        if (path.length) {
          pathArr = path.slice('1').split('/'); //All paths start with /data
        }


        const [initial, ...nested] = pathArr; //skip first child as it is always data
        if (nested.length) {

          const slug = nested.reduce((acc, prop, index, arr) => {

            acc = `${acc}/${prop}`;

            //console.log({ acc, prop, index })

            let value = isLastIndex(arr, index) ? this.getFieldValue(pathIndex, formGroup) : {}; //TODO [] if parent is an array instead of {}

            let propValue = undefined;


            try {
              propValue = jsonpatch.getValueByPointer(result, acc);
              if (propValue === undefined) {
                if (value !== null) {
                  applyOperation(result, {
                    op: "add",
                    path: acc,
                    value
                  });

                }


              } else {

                if (isLastIndex(arr, index)) { //only update end nodes to avoid overwriting parent


                  if (value !== null) {
                    applyOperation(result, {
                      op: "replace",
                      path: acc,
                      value
                    });
                  }

                }


              }
            } catch (e) {
              console.log(`unable to patch model ${prop} at index ${index}`)
            }

            return acc;
          }, '');


        }
      });



    }

    //console.log({ result, paths })

    return result;
  }

  updatePathsIfArrayPresent(data: any, basePath: string, paths: string[]): string[] {

    if (basePath) {

      const keys = basePath.split('/').filter(key => key); // Split the base path and filter out empty strings
      let current = data;

      // Navigate to the base path in the data
      for (let key of keys) {
        if (current[key] === undefined) {
          return paths; // Base path does not exist, return original paths
        }
        current = current[key];
      }

      // Check if the value at the base path is an array
      if (Array.isArray(current)) {
        const arrayLength = current.length;

        // Update paths to include the array index
        return paths.map(path => {
          const pathKeys = path.split('/').filter(key => key);
          const updatedPath = [basePath, arrayLength, ...pathKeys.slice(keys.length)].join('/');
          return updatedPath;
        });
      }
    }

    return paths; // Base path is not an array, return original paths
  }

  /**
   * return formgroup value for corresponding field index
   * @author Neil C
   * @param index 
   * @param formGroup 
   * @returns 
   */
  getFieldValue(index, formGroup: UntypedFormGroup) {

    let value = formGroup.get(`field_${index}`).value;

    if (value === undefined) {
      return null;
    }
    return value;


  }


  getDataByPath(data, path) {

    return get(data, path);

  }

  /**
   * Submit button configuration
   * @author Neil C
   * @param submitButton 
   */
  configureSubmitButton(submitButton) {
    //console.log({submitButton});

    const wrapperStyleProps = {};
    const { align, backgroundColor, borderColor, text, color, size } = submitButton;


    if (size && size != '') {
      this.submitButton['size'] = size;
    }

    if (color && color != '') {
      this.submitButton['color'] = color;
    }

    if (text) {
      const buttonText = this.multiLangPipe.transform(text).toString();
      if (buttonText) {
        this.submitButton['text'] = buttonText;
      }
    }

    if (backgroundColor) {
      this.submitButton['backgroundColor'] = backgroundColor;
    }

    if (borderColor) {
      this.submitButton['borderColor'] = borderColor;
    } else if ((!borderColor || borderColor == '') && backgroundColor) {
      this.submitButton['borderColor'] = backgroundColor;
    }

    if (align) {
      wrapperStyleProps['display'] = "flex";
      wrapperStyleProps['justify-content'] = align;
    }
    this.wrapperStyle = {
      "display": "block",
      ...wrapperStyleProps
    }
  }

  ngAfterViewInit() {
    if (this.submitButtonRef) {
      this.renderer.setStyle(this.submitButtonRef.nativeElement, 'cssText', `--background: ${this.submitButton['backgroundColor']}; --border-color:${this.submitButton["borderColor"]}; --color: ${this.submitButton["color"]}; 
      --background-hover: ${this.submitButton['backgroundColor']}; --background-hover-opacity: 1`);
    }
  }

  /**
   * OnList item select event emitter handler
   * @param $event 
   * @param field 
   */
  onListItemSelect($event, field) {

    const ctrl = this.form.get(field) as AbstractControl;
    ctrl.reset();

    let value = null;
    if ($event) {
      let { value } = $event;
      if (value) {
        ctrl.setValue(value)
      }

    }



  }


  /**
   * Refresh template DI by forcing freshness from serviceworker
   */
  // refreshData() {
  //   const snapshot = this.activatedRoute.snapshot;
  //   this.dataService.getData(snapshot)
  //     .subscribe((data) => {
  //       console.log('fetching data...')
  //       this.inProgress = false;

  //       this.swUpdate.activateUpdate()
  //         .then(() => {
  //           setTimeout(() => {
  //             console.log('reload')
  //             location.reload();
  //           }, 1500)
  //         })


  //     },
  //       (err) => {
  //         console.log(err);

  //       })
  // }

  /**
   * Set checkbox true and falsy values 
   * @param $event 
   * @author Neil C
   * @param i 
   */
  updateCheckbox($event, i) {
    // console.log($event, i)

    if ($event) {
      const { detail: { checked = false } } = $event;

      //console.log({ checked, i })
      const ctrl = this.form.get(`field_${i}`) as AbstractControl;

      ctrl.setValue(checked);
    }
  }

  uploadFile(index: number) {
    const fileInput = document.getElementById(`fileInput_${index}`) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

 

  onFileChange(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const maxSize = 1048576 * 10;
      if (input.files[0].size > maxSize) {
        alert('File size must be less than 10Mb');
        return;
      }
      this.fileNames[index] = input.files[0].name;
      this.uploadSuccess[index] = false; // Reset upload success status
      // Handle the file upload process
      if (!this.inProgress) this.uploadFileToServer(input.files[0], index);
    }
  }

  uploadFileToServer(file: File, index: number) {
    this.inProgress = true;
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('use_file_name', 'true');
    formData.append('unique_file', 'true');
    this.uploadInProgress = true;

    const xsrfToken = 'your-xsrf-token'; // Replace with the actual XSRF token

    this.apiService.postMultipart('di/data/assets/upload/file', formData, 'apiUrl', xsrfToken)
      .pipe(
        map((res: any) => {
          return res;
        })
      ).subscribe((res: any) => {
        if (res.requestStatus && res.data.url) {
          const url = res.data.url || '';
            this.onUploadFinish(url, index);
            this.uploadSuccess[index] = true; // Mark upload as successful
        } else {
          alert('File upload failed');
          this.uploadSuccess[index] = false; // Mark upload as failed
        }
        this.inProgress = false;
      }, (error) => {
        alert('File upload failed');
        this.uploadSuccess[index] = false; // Mark upload as failed
        this.inProgress = false;
      });
  }

  onUploadFinish(url: string, index: number) {
    // Set the uploaded file URL as the value of the form control
    let fileUrl = url;
    this.form.get(`field_${index}`).setValue(fileUrl);
    this.inProgress = false;
    console.log('File uploaded successfully:', url);
  }
}
